import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { supportEmail } from '../../constants';
import * as styles from './ResendLimitExceededMessage.scss';

class ResendLimitExceededMessage extends React.Component {
  render() {
    const { translate, className } = this.props;
    return (
      <div className={cx(styles.supportMessage, className)}>
        <div>
          <p>{translate('errorFieldMessages', 'youHaveExceededLimit')}</p>
          <p>
            <span>{translate('authenticationPage', 'askAgain')}</span>
            <span>
              {translate('authenticationPage', 'supportLabel')}{' '}
              <a href={`mailto:${supportEmail}`}>{supportEmail}</a>
            </span>
          </p>
        </div>
      </div>
    );
  }
}

ResendLimitExceededMessage.propTypes = {
  translate: PropTypes.func.isRequired,
  className: PropTypes.string
};

export default ResendLimitExceededMessage;
